import axiosInstance from 'utils/axiosInstance';
import {
  AssignInfo,
  HardwareDetail,
  HardwareFilter,
  HardwareHistory,
  HardwareInfo,
  HardwareResponse,
  HardwareType,
  ImportHardware,
} from '../types/hardwareTypes';

export const getHardware = async (filters: HardwareFilter) => {
  const { data } = await axiosInstance.post<ApiResponse<HardwareResponse>>(
    'api/hardware/List',
    filters,
  );
  return data;
};

export const getFormData = async () => {
  const { data } = await axiosInstance.get<ApiResponse<HardwareDetail>>(
    'api/hardware/createformdata',
  );
  return data;
};

export const createHardware = async (hardware: FormData) => {
  const { data } = await axiosInstance.post<ApiResponse<HardwareDetail>>(
    'api/hardware/create',
    hardware,
  );
  return data;
};

export const getHardwareById = async (id: number) => {
  const { data } = await axiosInstance.get<ApiResponse<HardwareDetail>>(
    `api/hardware/GetById/${id}`,
  );
  return data;
};

export const deleteHardware = async (id: number) => {
  const { data } = await axiosInstance.delete<ApiResponse<null>>(
    `api/hardware/Delete/${id}`,
  );
  return data;
};

export const getHardwareHistory = async (id: number) => {
  const { data } = await axiosInstance.get<ApiResponse<HardwareHistory[]>>(
    `api/hardware/History/${id}`,
  );
  return data;
};

export const getAffectHistory = async (id: number) => {
  const { data } = await axiosInstance.get<ApiResponse<HardwareHistory[]>>(
    `api/hardware/AffectHardwareHistory/${id}`,
  );
  return data;
};

export const assignHardwareToUser = async (hardware: AssignInfo) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    'api/hardware/AssignedTo',
    hardware,
  );
  return data;
};

export const getAssigneIt = async (info: HardwareInfo) => {
  const { data } = await axiosInstance.post<
    ApiResponse<{ id: string; text: string }[]>
  >('api/collaborateur/GetUsersSelect', info);
  return data;
};

export const unassignHardwareUser = async (info: {
  id: number;
  user: string;
}) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    'api/hardware/UnassignProfile',
    info,
  );
  return data;
};

export const updateHardware = async (hardware: FormData) => {
  const { data } = await axiosInstance.post<ApiResponse<HardwareDetail>>(
    'api/hardware/Update',
    hardware,
  );
  return data;
};

export const getHardwareTypes = async () => {
  const { data } = await axiosInstance.get<ApiResponse<HardwareType>>(
    'api/hardware/dataIndex',
  );
  return data;
};

export const updateHardwareStatus = async (status: {
  id: number;
  active: boolean;
}) => {
  const { data } = await axiosInstance.post<ApiResponse<HardwareDetail>>(
    'api/hardware/active',
    status,
  );
  return data;
};

export const getMaterials = async () => {
  const { data } = await axiosInstance.get<
    ApiResponse<{ id: string; text: string }[]>
  >('api/hardware/SelectItems');
  return data;
};

export const uploadHardwareFile = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);

  const { data } = await axiosInstance.post<ApiResponse<string>>(
    'api/hardware/Upload',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return data;
};

export const addHardwareExcelData = async (hardwares: ImportHardware[]) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    'api/hardware/AddExcelData',
    hardwares,
  );
  return data;
};

export const downloadHardwareTemplate = async () => {
  const { data } = await axiosInstance.get<ArrayBuffer>(
    'api/hardware/Download',
    {
      responseType: 'arraybuffer',
    },
  );
  return data;
};

export const deleteHardwareFile = async (fileId: number) => {
  const { data } = await axiosInstance.delete<ApiResponse<null>>(
    `api/hardware/deletefile/${fileId}`,
  );
  return data;
};
